import { render, staticRenderFns } from "./UcWorksheetInvoiceLineAccountings.yaml?vue&type=template&id=ecb620a6&component"
import script from "./UcWorksheetInvoiceLineAccountings.yaml?vue&type=script&lang=ts&component"
export * from "./UcWorksheetInvoiceLineAccountings.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports